export default {
    state: {
        categories: [],
        category_id: null,
        errors: {},
        url: '/api/hms/inspections/categories',
        meta: {
            current_page: 1,
            per_page: 10,
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'name', label: 'Name'},
                {key: 'status', label: 'Status', thClass: 'text-center', tdClass: 'text-center'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        form: {
            name: '',
        },
    },

    getters: {
        getInspectionCategoriesMeta: state => state.meta,

        getInspectionCategoryTableFields: state => state.table.fields,

        getInspectionCategoryForm: state => state.form,

        getInspectionCategoryErrors: state => state.errors,
    },

    mutations: {
        resetInspectionCategoriesMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setInspectionCategories: (state, payload) => {
            state.categories = payload;
        },

        setInspectionCategoriesMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setInspectionCategoryErrors: (state, payload) => {
            state.errors = payload;
        },

        setInspectionCategoryForm: state => {
            state.form = {
                name: '',
            };

            state.errors = {};
        },
    },

    actions: {
        fetchInspectionCategories: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setInspectionCategories', response.data);

                        commit('setInspectionCategoriesMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setInspectionCategoryErrors', error.response.data.errors);

                        reject();
                    });
            });
        },

        fetchInspectionEditCategory: ({state, commit}, category_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + category_id + '/edit')
                    .then(response => {
                        state.category_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitInspectionCategory: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setInspectionCategoryErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateInspectionCategory: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.category_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setInspectionCategoryErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteInspectionCategory: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.category_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
